'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AuthenticationPolicySection, loginEmailPoliciesQueryOptions, loginMethodPoliciesQueryOptions, mfaSettingsQueryOptions } from '@/features/identity-policy';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { queryClient } from '@/lib/queryClient';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/settings/authentication-method/')({
  loader: async () => {
    await Promise.all([queryClient.ensureQueryData(mfaSettingsQueryOptions()), queryClient.ensureQueryData(loginEmailPoliciesQueryOptions()), queryClient.ensureQueryData(loginMethodPoliciesQueryOptions())]);
  },
  component: AuthenticationMethodSettingsPage
});
function AuthenticationMethodSettingsPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.settings.authentication.settings.authenticationMethod'
  });
  return <AuthenticationPolicySection title={t('title')} description={t('description')} />;
}